'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const LargeHouseIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="LargeHouseIcon">
      <svg width="40" height="38" viewBox="0 0 40 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.97485 34.4246V17.5949L19.9994 3.57031L34.024 17.5949V34.4246C34.024 35.9735 32.7683 37.2295 31.2191 37.2295H8.77971C7.23057 37.2295 5.97485 35.9737 5.97485 34.4246Z"
          fill="#D8DCE5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.016 1.58915C19.1114 0.494291 20.8868 0.494291 21.9823 1.58915L38.8117 18.4189C40.3122 19.9714 39.5694 22.5663 37.4745 23.0894C36.5354 23.324 35.5417 23.0577 34.8457 22.3849L19.9991 7.53858L5.15253 22.3849C3.59996 23.8854 1.00539 23.1426 0.481962 21.0477C0.247391 20.1086 0.513677 19.1149 1.18653 18.4189L18.016 1.58915Z"
          fill="#3D517B"
        />
      </svg>
    </SvgIcon>
  )
}

LargeHouseIcon.propTypes = {
  sx: PropTypes.object
}
